module.exports = "<jhi-page-ribbon></jhi-page-ribbon>\n<div id=\"main\" class=\"container\">\n    <div>\n        <router-outlet name=\"navbar\"></router-outlet>\n    </div>\n    <div class=\"\">\n        <router-outlet></router-outlet>\n        <router-outlet name=\"popup\"></router-outlet>\n    </div>\n</div>\n<jhi-footer></jhi-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/main/main.component.html
// module id = 458
// module chunks = 0